var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1119_20120)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1119_20120",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 2,
  width: 12,
  height: 12
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 2H2V14H14V2Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1119_20120)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.52866 9.55534C4.52866 10.2523 3.96557 10.8112 3.27279 10.8112C2.58001 10.8112 2.01271 10.2481 2.01271 9.55534C2.01271 8.86254 2.57579 8.29947 3.26857 8.29947H4.52444V9.55534H4.52866Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.1547 9.55546C5.1547 8.85846 5.71779 8.29959 6.41057 8.29959C7.10335 8.29959 7.66643 8.86268 7.66643 9.55546V12.6967C7.66643 13.3937 7.10335 13.9526 6.41057 13.9526C5.71779 13.9526 5.1547 13.3937 5.1547 12.6967V9.55546Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.4147 4.50379C5.71768 4.50379 5.15884 3.94072 5.15884 3.24793C5.15884 2.55515 5.7219 1.99207 6.4147 1.99207C7.10748 1.99207 7.67055 2.55515 7.67055 3.24793V4.50379H6.4147Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.41515 5.14069C7.11215 5.14069 7.67101 5.70377 7.67101 6.39655C7.67101 7.08933 7.10792 7.65242 6.41515 7.65242H3.26125C2.56425 7.65242 2.00538 7.08933 2.00538 6.39655C2.00538 5.70377 2.56847 5.14069 3.26125 5.14069H6.41515Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4516 6.39667C11.4516 5.69967 12.0147 5.14081 12.7075 5.14081C13.4003 5.14081 13.9633 5.7039 13.9633 6.39667C13.9633 7.08945 13.4003 7.65254 12.7075 7.65254H11.4516V6.39667Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.825 6.39849C10.825 7.09549 10.2619 7.65436 9.56914 7.65436C8.87634 7.65436 8.31328 7.09129 8.31328 6.39849V3.24882C8.31328 2.55182 8.87634 1.99295 9.56914 1.99295C10.2619 1.99295 10.825 2.55182 10.825 3.24882V6.39849Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5639 11.4404C10.2609 11.4404 10.8198 12.0035 10.8198 12.6963C10.8198 13.389 10.2567 13.9521 9.5639 13.9521C8.87112 13.9521 8.30803 13.389 8.30803 12.6963V11.4404H9.5639Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.56401 10.8112C8.86701 10.8112 8.30814 10.2481 8.30814 9.55534C8.30814 8.86256 8.87123 8.29947 9.56401 8.29947H12.7179C13.4149 8.29947 13.9738 8.86256 13.9738 9.55534C13.9738 10.2481 13.4107 10.8112 12.7179 10.8112H9.56401Z",
  fill: "currentColor"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1119_20120"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(2 2)"
})))));
export default SvgSlack;